import React from "react";
import logApi from '../../services/api/logError';
import * as SessionHandler from '../../services/sessionHandler';

class ErrorBoundaryClass extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
        this.handleReset = this.handleReset.bind(this);
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    async componentDidCatch(error, errorInfo) {
        this.setState({ error, errorInfo });
        await logApi.logErrorToServer(error, errorInfo);

        // Redirect to session expired page and logout
        let redirectURL = `${window.location.origin}/error-session-expired`;
        await SessionHandler.handleLogout(redirectURL);
    }

    handleReset() {
        this.setState({ hasError: false, error: null, errorInfo: null });
        if (typeof this.props.onReset === 'function') {
            this.props.onReset();
        }
    }

    render() {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    }
}

const ErrorBoundary = (props) => <ErrorBoundaryClass {...props} />;
export default ErrorBoundary;
